import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';
import { Organization } from './organization.model';


export class RoleSearchVO {
    applicationId: number;
    name: string;
    id: number;
    pageNo: number;
    pageSize: number;
    username: string;
}
export class RoleVO {
    id: number;
    name : string;
    applicationId : number;
    isActive : string;
    description: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
    associateTypes: any[];
   // roleAssociateTypeXrefs : RoleAssociateTypeXrefVO[];
    roleParticipantXrefs :RoleParticipantXrefVO[];
    
}
export class Locations {
    id: number;
    locationNumber: Number;
    locationName: string;
    locationEmail: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
    locationVOList: Locations[];

}
export class RoleAssociateTypeXrefVO {
    id: number;
    roleVo: RoleVO;
    roleId: number;
    associateTypeId: number;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
    //associateTypeName: string;
}
export class ParticipantVO {
    id: number;
    participantName: string;
    locationId: number;
    type: string;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
    //  participantAddress: ParticipantAddress;
    // participantContacts: Array<ParticipantContacts>;
    
}
export class ParticipantsSearch {
    participantName: string;
    status: string;
    pageNo: number;
    pageSize: number;
    userName: string;
}

export class ParticipantResponse {
    participantVOList: Array<ParticipantVO>;
    apiResponseVO: ApiResponse;
}
export class participantsVOList {
    id: number;
    roleId: number;
    type: number;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class RoleParticipantXrefVO{
    id: number;
    roleVo: RoleVO;
    roleId: number;
    organization: Organization;
    organizationId: number;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}

export class RoleResponse{
    apiResponseVO: ApiResponse;
    roleVOList: RoleVO[];
}


